import LoginLink from './loginLink'

export default LoginLink
